window.addEventListener('load', () => {
  // DOM element references
  const formElement               = document.querySelector('.page-product-form');
  const productId                 = formElement?.getAttribute('data-product-id');
  const productType               = formElement?.getAttribute('data-product-type');
  const metaDataDiv               = document.getElementById('meta-data');
  const collectionProdArray       = document.querySelectorAll('.product-item');
  const spinner                   = document.querySelector('.loader');
  const announcementItem          = document.querySelectorAll('announcement-bar-item');
  const relatedProductsContainer  = document.querySelector('.related-products-container');
  const colorTarget               = document.querySelector('.option-name-value');
  const inventoryTextItems        = document.querySelectorAll('.inventory');
  const productInventoryWrapper   = document.querySelector('product-inventory');


  // FJERNET 29-09-2026. Her laa en loekke der gik hvert eneste <a> paa siden
  // igennem og haengte ?filter.v.availability=1 paa alle links til
  // /collections/ uden query. Maalt paa oneopensky.com: 522 links paa én side,
  // mod 9 forekomster i serverens egen HTML.
  //
  // Parameteren gjorde stort set ingenting paa selve kollektionsforsiden:
  // /collections/all viste 4.604 varer uden den og 4.603 med. Den betoed
  // til gengaeld at hele den interne linkstruktur pegede paa parameteriserede
  // URL'er.
  //
  // Parameteren bruges stadig - den er det eneste der faar stoerrelsesfiltret
  // til kun at vise varer man kan koebe (XS: 848 mod 227). Den saettes nu
  // praecis naar kunden vaelger en stoerrelse, af
  // snippets/oos-facet-lager-com.liquid. Omdirigeringsscriptet i
  // layout/theme.liquid, der gjorde det samme en tredje gang, er ogsaa vaek.


  // TILFOEJET 30-09-2026: SPROGPRAEFIKS PAA PRODUKTLINKS
  //
  // Farvefirkanterne blev bygget med en rod-relativ sti, '/products/' + handle.
  // Paa en tysk side sendte det kunden ud af sit eget sprog: maalt paa
  // /de-de/products/ak-cyclic-gore-tex-2l-jacket-atomic-shatter endte et klik
  // paa en farve paa en side med lang="en".
  //
  // Shopify.routes.root er '/de-de/' paa tysk og '/' paa engelsk, saa den er
  // den rigtige kilde. Falder den bort, opfoerer koden sig som foer.
  function oosProduktUrl(handle) {
    var rod = '/';
    try {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) rod = Shopify.routes.root;
    } catch (e) {}
    if (rod.charAt(rod.length - 1) === '/') rod = rod.slice(0, -1);
    return rod + '/products/' + handle;
  }

 
  // Accordion UI toggle
  document.addEventListener('click', function(event) {
    const acc = event.target.closest('.custom-accordion');
    if (!acc) return; // Click was not on a .custom-accordion
    
    acc.classList.toggle("active");
    const panel = acc.nextElementSibling;
    if (panel) {
      panel.style.display = (panel.style.display === "flex") ? "none" : "flex";
    }
  });


  // Inventory setup for single product
  if (metaDataDiv) {
    const mainId = metaDataDiv.getAttribute('data-main-product-id');
    if (mainId) {
      console.log('Set inventory single product');
    }
  }

  // Inventory setup for product collection
  if (collectionProdArray.length > 0) {
    const idArray = [];
    collectionProdArray.forEach((prodItem) => {
      const mainId = prodItem.getAttribute('data-main-product-id');
      if (mainId) idArray.push(mainId);
    });
    console.log('Set inventory collection');
  }

  // Listen for variant change and trigger inventory and UI updates
  let initialVariantId = formElement?.getAttribute('data-variant-id');
  document.addEventListener('variant:changed', (event) => {
    if (productInventoryWrapper) {
      
      //productInventoryWrapper.style.opacity = '0';
    }
    
    //inventoryTextItems.forEach((e) => e.style.opacity = "0");

    
    const variant = event.detail.variant;
    console.log(variant.id);
    fetchAvailability(variant.id);
    // Optional: handleRelatedProducts(); can be triggered here if needed
  });

  // Initial load methods
  handleRelatedProducts();
  getMetafieldsFromExternal(productId);
  responsiveAnnouncementBarFix();
  fetchAvailability(initialVariantId);

  // Helper: get current product handle from URL
  function getCurrentHandle() {
    return window.location.pathname.split('/').filter(Boolean).pop();
  }

  // Fix layout issue for announcement bar on desktop
  function responsiveAnnouncementBarFix() {
    if (window.innerWidth > 768) {
      announcementItem.forEach(() => {
        console.log('responsiveAnnouncementBarFix');
      });
    }
  }

  // Fetch and display related products by SKU or GID
  async function handleRelatedProducts() {
    try {
      if (!metaDataDiv) throw new Error('Meta data div not found.');

      const identifier = metaDataDiv.getAttribute('data-identifier');
      const relatedObjectKeysArray = metaDataDiv.getAttribute('data-related-array');
      if (relatedObjectKeysArray) {
        if (identifier === "gid") {
          const relatedProductsIdentifier = JSON.parse(`[${relatedObjectKeysArray}]`);
          await queueProductsByGID(relatedProductsIdentifier);
        } else {
          const relatedProductsIdentifier = relatedObjectKeysArray.split(',');
          await queueProductsBySKU(relatedProductsIdentifier);
        }
      }

      mouseOverEffectForRelatedItems();
    } catch (error) {
      //console.error('Error while handling related products: ', error);
      console.log('[INFO] No related products found');
    } finally {
      if (spinner) spinner.classList.add('hidden');
    }
  }

  // Fetch products via GID using Shopify GraphQL Storefront API
  async function queueProductsByGID(gidsArray) {
    const accessToken = "da4df6e82f8d63a8842fdca0e65b9fe0";
    gidsArray = gidsArray.map(id => `gid://shopify/Product/${id}`);

    fetch("https://one-opensky.myshopify.com/api/2023-10/graphql.json", {
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": accessToken,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        query: `
          {
            nodes(ids: ${JSON.stringify(gidsArray)}) {
              ... on Product {
                id
                title
                handle
                sku
                media(first: 3) {
                  nodes {
                    previewImage {
                      url
                    }
                  }
                }
                metafield(key: "farve", namespace: "global") {
                  value
                }
              }
            }
          }
        `
      })
    })
    .then(response => response.json())
    .then(data => {
      insertRelatedProducts(data);
      mouseOverEffectForRelatedItems();
    });
  }

  // Insert product swatches for related products
  function insertRelatedProducts(payload) {
    if (!relatedProductsContainer) return;

    // 1. Normalise inputs
    const products   = payload?.data?.nodes ?? payload; 
    const identifier = payload?.data ? 'gid' : 'sku';
    const current    = getCurrentHandle();

    // 2. Build markup once, no += in loops
    const frag = document.createDocumentFragment();

    products
      .filter(p => (p.totalInventory ?? p.inventoryQuantity) > 0) 
      .forEach(p => {
        const image =
          identifier === 'gid'
            ? p.media.nodes[0]?.previewImage.url ?? ''
            : p.preview_image;

        const color = identifier === 'gid' ? p.metafield.value : p.metafield;

        const a = document.createElement('a');
        // Sprogpraefiks, se oosProduktUrl oeverst i filen
        a.href  = oosProduktUrl(p.handle);
        a.dataset.colorvalue = String(color);
        a.className = `variant-related-color variant-swatch__item${
          current === p.handle ? ' selected' : ''
        }`;

        a.innerHTML = /*html*/ `
          <span class="visually-hidden">${p.title}</span>
          <img
            src="${image}"
            alt="${p.title}"
            class="variant-swatch__image"
            loading="lazy"
            sizes="(max-width:740px) 64px, 72px"
            srcset="${image} 64w, ${image} 72w, ${image} 128w,
                    ${image} 144w, ${image} 192w, ${image} 216w"
          >
        `;

        frag.appendChild(a);
      });

    // 3. One paint -> fast UI update
    relatedProductsContainer.replaceChildren(frag);
  }

  // Add hover color label for related products
  function mouseOverEffectForRelatedItems() {
    const relatedItems = document.querySelectorAll('.variant-related-color');
    if (!colorTarget) return;

    const originalColor = colorTarget.getAttribute('data-original-color');
    relatedItems.forEach((item) => {
      item.addEventListener('mouseover', (e) => {
        const color = e.target.getAttribute('data-colorvalue');
        if (color && color !== "null") colorTarget.textContent = color;
      });
      item.addEventListener('mouseleave', () => {
        colorTarget.textContent = originalColor;
      });
    });
  }

  // Fetch related products by SKU from custom API
  async function queueProductsBySKU(skus) {
    const apiUrl = 'https://shopify.api.nomilk.dev/one_open_sky/metafields.php';
    try {
      const skusParam = skus.join(',');
      const refereDomain = window.location.hostname.replace(/^www\./, ''); // e.g. "bsport.dk"
      
      const response = await fetch(
        `${apiUrl}?skus=${encodeURIComponent(skusParam)}&refere_domain=${encodeURIComponent(refereDomain)}`
      );
      const data = await response.json();
      
      const uniqueProducts = data
        .map(item => item.product)
        .filter((product, index, self) => index === self.findIndex(p => p.id === product.id));

      console.log('[INFO] - Products queued by SKU');
      console.log(uniqueProducts);
      insertRelatedProductsCollection(uniqueProducts);
      insertRelatedProducts(uniqueProducts);
    } catch (error) {
      console.log('Error while queuing products by SKUs:', error);
    }
  }

  // Render color swatches for collection grid
  function insertRelatedProductsCollection(data) {
    const targets = document.querySelectorAll('.wrap-available-colors .target');
    targets.forEach((targetElement) => {
      targetElement.innerHTML = '';
      data.forEach((product) => {
        // Sprogpraefiks, se oosProduktUrl oeverst i filen
        const productUrl = oosProduktUrl(product.handle);
        const imageUrl = product.preview_image;
        const colorValue = product.metafield;

        targetElement.innerHTML += `
          <a href="${productUrl}" data-sku="" data-colorvalue="${colorValue}" class="collection-variant-swatch__item">
            <img src="${imageUrl}" alt="${product.title}" loading="lazy"
              sizes="(max-width: 740px) 64px, 72px"
              srcset="${imageUrl} 64w, ${imageUrl} 72w, ${imageUrl} 128w, ${imageUrl} 144w, ${imageUrl} 192w, ${imageUrl} 216w">
          </a>
        `;
      });
    });
  }

  // Trigger availability check for a variant ID
  function fetchAvailability(variantId) {
    if (!variantId) return;
    if(productType == "bundle-product") return;
    console.log('Not bundle');
    setInventoryQuantity(variantId);
  }

  // Query inventory data from PHP endpoint
  async function setInventoryQuantity(variantId) {
    const phpEndpoint = "https://shopify.api.nomilk.dev/one_open_sky/locations-data.php";
    try {
      const response = await fetch(phpEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ variantId }),
      });
      if (!response.ok) throw new Error(`Network response was not ok: ${response.statusText}`);

      const data = await response.json();
      
      console.log('__Stock data__');
      console.log(data);

      const edges = data.data?.productVariant?.inventoryItem?.inventoryLevels?.edges || [];
      if (!edges.length) return;

      handleStockData(edges);
    } catch (error) {
      console.error("Error fetching inventory data:", error);
    }
  }

function handleStockData(edges) {
  let webStock = 0;
  let hasCopenhagen = false;
  const locationMap = new Map();  

  // 1. Collect raw numbers
  edges.forEach(({ node }) => {
    const loc  = node.location.name;
    const qty  = node.quantities.find(q => q.name === 'on_hand')?.quantity || 0;

    locationMap.set(loc, qty);
    if (loc === 'København'){
      hasCopenhagen = true;
    } 
    else{
      webStock += qty;
    } 
  });

  // 2. Inject synthetic Herning row
  locationMap.set('Herning', webStock);

  // 3. Render every location once
  locationMap.forEach((qty, loc) =>
    renderAvailability(loc, qty, webStock)
  );

  // 4. Ensure København row exists even when API omitted it
  if (!hasCopenhagen) renderAvailability('København', 0, webStock);

  toggleWebshopInventory(webStock);
}

function renderAvailability(loc, qty, webStock) {
  const el = document.querySelector(
    `.store-availability-information[data-location-name="${loc}"]`
  );
  if (!el) return;

  el.setAttribute('data-on-hand', qty);

  const setVisible = (selector, show) =>
    el.querySelectorAll(selector).forEach(n => n.style.display = show ? 'flex' : 'none');

  // Rule A: show in-stock when positive for the location **or** aggregate web stock
  const isActive = qty > 0 || (loc === 'Herning' && webStock > 0);

  setVisible('.in-stock-display',  isActive);
  setVisible('.out-of-stock-display', !isActive);
  el.classList.toggle('active',   isActive);
  el.classList.toggle('inactive', !isActive);
}


// Update webshop UI depending on stock levels
function toggleWebshopInventory (webStock = 0) {
  /* --- DOM look-ups ------------------------------------------------------ */
  const addToCartBtn   = document.getElementById('AddToCart');
  const inventoryWrap  = document.querySelector('.product-form__inventory-wrapper');
  const inStockMsg     = document.querySelector('.inventory.in-webshop-stock');
  const outOfStockMsg  = document.querySelector('.inventory.not-in-webshop-stock');

  /* --- Basic guard-rail --------------------------------------------------- */
  if (!addToCartBtn || !inventoryWrap) return;   // nothing to update

  /* --- Calculate state ---------------------------------------------------- */
  const outOfStock = webStock <= 0;

    console.log('Not digital');
    /* --- Button ------------------------------------------------------------- */
    addToCartBtn.classList.toggle('inactive', outOfStock);
    addToCartBtn.innerText           = outOfStock ? 'Ikke på lager' : 'Læg i kurv';
    //addToCartBtn.style.pointerEvents = outOfStock ? 'none'          : 'auto';
  

  /* --- Inventory messaging ------------------------------------------------ */
  if (inStockMsg)    inStockMsg.style.display    = outOfStock ? 'none' : 'flex';
  if (outOfStockMsg) outOfStockMsg.style.display = outOfStock ? 'flex' : 'none';
  inventoryWrap.style.opacity = '1';
}

// Insert fetched metafields into specification section
function insertMetafieldData(data) {
  const dataContainer = document.getElementById('product-specifications');
  const disallowedSpecificationsElement = document.getElementById('disallowed-product-specifications');
  if (!dataContainer || !disallowedSpecificationsElement) return;

  const specContainer = document.querySelector('.js-specifications');
  const allProdMeta = data.data.product.metafields.edges;
  const disallowedSpecifications = disallowedSpecificationsElement.getAttribute('data-disallowed-specifications')
    .split(',')
    .map(item => item.trim());

  allProdMeta.forEach((meta) => {
    const metaName = meta.node.definition ? meta.node.definition.name : 'N/A';
    const metaValue = meta.node.value;
    if (!disallowedSpecifications.includes(meta.node.key)) {
      createSpecElement(metaName, metaValue, specContainer);
    }
  });
}

// Render a single spec item
function createSpecElement(title, value, container) {
  if (!container) return;

  // Try to parse the value if it's a JSON array
  let cleanedValue = value;
  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed)) {
      cleanedValue = parsed.join(', ');
    }
  } catch (e) {
    // Not a JSON stringified array; keep original value
  }

  const targetDiv = document.createElement('div');
  targetDiv.classList.add('specification');

  const titleDiv = document.createElement('div');
  titleDiv.classList.add('title');
  titleDiv.textContent = title;

  const valueDiv = document.createElement('div');
  valueDiv.classList.add('final');
  valueDiv.textContent = cleanedValue;

  targetDiv.append(titleDiv, valueDiv);
  container.appendChild(targetDiv);
}
 

// Fetch external metafield data
async function getMetafieldsFromExternal(productId) {
  if (!productId) return;
  try {
    const url = `https://shopify.api.nomilk.dev/one_open_sky/product-page-metadata-global.php?product_gid=${productId}`;
    const response = await fetch(url);
    const data = await response.json();
    insertMetafieldData(data);
  } catch (error) {
    console.error('Error fetching metafields:', error);
  }
}

const sizeGuidePop = document.querySelector('.pop-up-container');
const closePop = document.querySelector('.close');
const openPop = document.querySelector('.open-size-guide');

if (closePop && sizeGuidePop && openPop) {
  openPop.addEventListener('click', () => {
    sizeGuidePop.classList.remove('hidden');
  });

  closePop.addEventListener('click', () => {
    sizeGuidePop.classList.add('hidden');
  });
}


const fade = document.querySelector('.scroll-fade');
if(fade){
  const scrollable = document.querySelector('scrollable-content');
  
  function updateFade() {
    const scrollLeft = scrollable.scrollLeft;
    const maxScrollLeft = scrollable.scrollWidth - scrollable.clientWidth;
    
    if (scrollLeft >= maxScrollLeft - 1) {
      fade.style.opacity = '0';
    } else {
      fade.style.opacity = '1';
    }
  }
  
  scrollable.addEventListener('scroll', updateFade);
  window.addEventListener('resize', updateFade);
  
  // Initial check
  updateFade();
}

const header = document.querySelector('store-header');
const headerOffset = header.offsetTop;
window.addEventListener('scroll', () => {
  const scrollPosition = window.scrollY || window.pageYOffset;

  if (scrollPosition > headerOffset) {
    // Header is now sticky / has moved from original position
    header.classList.add('is-sticky');
    // You can trigger any other logic here
  } else {
    // Header is at original position
    header.classList.remove('is-sticky');
  }
});

});